import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import '../styles/Clientes.css';
import { reporteService } from '../services/api';

const DebenPagar = () => {
  const [prestamosHoy, setPrestamosHoy] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { codigo } = useParams();

  // Función para construir rutas con el código del tenant
  const getRoute = (path) => {
    return codigo ? `/${codigo}${path}` : path;
  };

  const irAlReportePrestamo = (prestamoId) => {
    if (!prestamoId) return;
    navigate(getRoute(`/pagos?opcion=plan&prestamoId=${prestamoId}`));
  };

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      setError('');

      const response = await reporteService.getDebenPagarHoy();

      setPrestamosHoy(response.data.prestamos || []);

    } catch (err) {
      console.error('Error cargando datos:', err);
      setError(err.response?.data?.error || err.message || 'Error al cargar los datos');
    } finally {
      setLoading(false);
    }
  };

  const formatMoney = (amount) => {
    return `RD$ ${(amount || 0).toLocaleString('es-DO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };

  if (loading) return <div className="loading">Cargando...</div>;

  return (
    <div className="clientes-page">
      <div className="clientes-header">
        <h1>Préstamos que deben pagar HOY</h1>
        <button
          className="btn"
          onClick={() => navigate(getRoute('/dashboard'))}
          style={{background: '#666', color: '#fff'}}
        >
          ← Volver al Dashboard
        </button>
      </div>

      {error && <div className="banner error">{error}</div>}

      {/* Préstamos que deben pagar hoy */}
      <div className="card" style={{marginBottom: '2rem'}}>
        <div className="card-title" style={{background: '#2196F3'}}>
          Préstamos que deben pagar hoy ({prestamosHoy.length})
        </div>

        {prestamosHoy.length === 0 ? (
          <p style={{padding: '1rem', textAlign: 'center', color: '#666'}}>
            No hay préstamos que deban pagar hoy
          </p>
        ) : (
          <div style={{overflowX: 'auto'}}>
            <table className="table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Cuota del día</th>
                  <th>Cuotas</th>
                  <th>Saldo</th>
                  <th>Modalidad</th>
                  <th>Dirección</th>
                  <th>Negocio</th>
                  <th>Celular</th>
                </tr>
              </thead>
              <tbody>
                {prestamosHoy.map((prestamo) => (
                  <tr key={prestamo.id}>
                    <td>
                      <div style={{display: 'flex', flexDirection: 'column'}}>
                        <span>{prestamo.cliente?.nombres} {prestamo.cliente?.apellidos}</span>
                        <button
                          type="button"
                          onClick={() => irAlReportePrestamo(prestamo.id)}
                          style={{
                            marginTop: '0.2rem',
                            alignSelf: 'flex-start',
                            background: 'none',
                            border: 'none',
                            padding: 0,
                            color: '#1976d2',
                            cursor: 'pointer',
                            fontSize: '0.9rem'
                          }}
                          title="Abrir reporte de pagos"
                        >
                          ID #{prestamo.id}
                        </button>
                      </div>
                    </td>
                    <td>{formatMoney(prestamo.cuota_diaria)}</td>
                    <td>{prestamo.cuotas_pagadas} / {prestamo.cuotas}</td>
                    <td>{formatMoney(prestamo.saldo)}</td>
                    <td>{prestamo.modalidad}</td>
                    <td>{prestamo.cliente?.direccion || 'N/A'}</td>
                    <td>{prestamo.cliente?.negocio || 'N/A'}</td>
                    <td>{prestamo.cliente?.celular || 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default DebenPagar;
